import {Action} from '@ngrx/store';
import {Culture} from '../models/culture';
import {type} from '../utilities/type';

export const culturesActionTypes = {
  LOAD: type('[Cultures] Load'),
  LOAD_SUCCESS: type('[Cultures] Load Success'),
  LOAD_FAIL: type('[Cultures] Load Fail'),
  UPDATE: type('[Cultures] Update')
};

export class LoadCulturesAction implements Action {
  readonly type = culturesActionTypes.LOAD;
  constructor() {}
}

export class LoadCulturesSuccessAction implements Action {
  readonly type = culturesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Culture[]) {}
}

export class LoadCulturesFailAction implements Action {
  readonly type = culturesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class UpdateCulturesSuccessAction implements Action {
  readonly type = culturesActionTypes.UPDATE;
  constructor(public payload?: Culture[]) {}
}
